import { useState } from 'react';
import Button from 'design-system/src/components/Button/Button';
import ButtonRow, { Alignment } from 'design-system/src/components/ButtonRow/ButtonRow';
import PharmacySearch from '../../PharmacySearch/PharmacySearch';
import { ActionCard } from '../../ActionCard';
import { OtherRequestButton } from './shared/OtherRequestButton';

type PharmacyRequestedActionsProps = {
  setShowDeclineModal: (show: boolean) => void;
  setShowNewFollowupTaskModal: (show: boolean) => void;
  handleTaskResponse: (response: string) => Promise<void>;
  rxId: string;
};

export const PharmacyRequestedActions = ({
  setShowDeclineModal,
  setShowNewFollowupTaskModal,
  handleTaskResponse,
  rxId,
}: PharmacyRequestedActionsProps) => {
  const [hasSelection, setHasSelection] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitTrigger, setSubmitTrigger] = useState(0);

  const handlePharmacySubmit = () => {
    // After pharmacy is saved, respond to the task
    handleTaskResponse('select_preferred_pharmacy');
  };

  const handleContinue = () => {
    setSubmitTrigger((prev) => prev + 1);
  };

  return (
    <ActionCard>
      <PharmacySearch
        rxId={rxId}
        onSubmit={handlePharmacySubmit}
        onSelectionChange={setHasSelection}
        onSubmittingChange={setIsSubmitting}
        submitTrigger={submitTrigger}
      />
      <ButtonRow align={Alignment.SpaceBetween} fullWidth>
        <ButtonRow>
          <Button variant="secondary" size="sm" onClick={() => setShowDeclineModal(true)} disabled={isSubmitting}>
            Cancel prescription
          </Button>
          <OtherRequestButton setShowNewFollowupTaskModal={setShowNewFollowupTaskModal} />
        </ButtonRow>
        <Button variant="primary" size="sm" onClick={handleContinue} disabled={!hasSelection} isLoading={isSubmitting}>
          Continue
        </Button>
      </ButtonRow>
    </ActionCard>
  );
};
